import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from 'react-router-dom';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import {DevSupport} from "@react-buddy/ide-toolbox";
import {ComponentPreviews, useInitial} from "./dev";

// Global error handler to catch third-party library errors
window.addEventListener('unhandledrejection', event => {
    // Handle h1-check.js related promise rejections
    if (event.reason && event.reason.toString().includes('Cannot convert undefined or null to object')) {
        console.warn('h1-check.js library error caught and suppressed:', event.reason);
        event.preventDefault();
        return;
    }
    console.error('Unhandled promise rejection:', event.reason);
});

window.addEventListener('error', event => {
    // Log error but don't break the app for third-party library errors
    if (event.filename && event.filename.includes('h1-check.js')) {
        console.warn('Third-party library error caught:', event.error);
        event.preventDefault(); // Prevent the error from breaking the app
        return false;
    }

    // Also catch Object.keys errors that might be from h1-check.js
    if (event.error && event.error.message && event.error.message.includes('Cannot convert undefined or null to object')) {
        console.warn('Null/undefined object error caught and suppressed:', event.error);
        event.preventDefault();
        return false;
    }
});

// Override Object.keys to be more defensive
const originalObjectKeys = Object.keys;
Object.keys = function (obj) {
    if (obj === null || obj === undefined) {
        console.warn('Object.keys called with null/undefined, returning empty array');
        return [];
    }
    return originalObjectKeys(obj);
};

const theme = createTheme({
    typography: {
        fontFamily: 'Montserrat',
    },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <ThemeProvider theme={theme}>
            <DevSupport ComponentPreviews={ComponentPreviews}
                        useInitialHook={useInitial}
            >
                <App/>
            </DevSupport>
        </ThemeProvider>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
